import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { RootState } from "../store";
import { Alliance, AllianceCreateEdit, AlliancesType, Region } from "../../types/slices/alliancesType";

const initialState: AlliancesType = {
  statusAlliances: ApiStatus.FETCHED,
  errorMessage: undefined,
  alliances: [] as Alliance[],
  editAlliance: {} as AllianceCreateEdit,
  selectedAlliance: {} as Alliance,
  isEdit: false,
  openModal: false,
  selectedRegion: {} as Region,
  regions: [],
};

const allianceSlice = createSlice({
  name: "alliance",
  initialState,
  reducers: {
    onFetchAlliances(state, { payload }: { payload: Alliance[] }) {
      state.statusAlliances = ApiStatus.FETCHED;
      state.alliances = payload;
      state.errorMessage = undefined;
    },
    changeStatusAlliaces(state, { payload }: { payload: ApiStatus }) {
      state.statusAlliances = payload;
    },
    onSetEditAlliance(state, { payload }: { payload: AllianceCreateEdit }) {
      state.editAlliance = payload;
    },
    onSetSelectedAlliance(state, { payload }: { payload: Alliance }) {
      state.selectedAlliance = payload;
    },
    onSetOpenModal(state, { payload }: { payload: boolean }) {
      state.openModal = payload;
    },
    onChangeIsEdit(state, { payload }: { payload: boolean }) {
      state.isEdit = payload;
    },
    onFetchRegions(state, { payload }: { payload: Region[] }) {
      state.statusAlliances = ApiStatus.FETCHED;
      state.regions = payload;
      state.errorMessage = undefined;
    },
    onSetSelectedRegion(state, { payload }: { payload: Region }) {
      state.selectedRegion = payload;
    },
  },
});

export const selectAllianceState = (state: RootState) => state.allianceSlice;
export default allianceSlice.reducer;

export const {
  onFetchAlliances,
  changeStatusAlliaces,
  onSetEditAlliance,
  onSetSelectedAlliance,
  onSetOpenModal,
  onChangeIsEdit,
  onFetchRegions,
  onSetSelectedRegion,
} = allianceSlice.actions;